import { useQuery } from "@tanstack/react-query";
import { ConfigApi } from "../api/ConfigApi";

export function useStartConfig(baseUrl: string = "prove") {
  const queryKey = ["startConfig", baseUrl];

  const { isLoading, error, data, refetch } = useQuery({
    queryKey: queryKey,
    queryFn: () => ConfigApi.getStartConfig(
      window.location.hostname === 'localhost'
      ? window.location.hostname + (window.location.port ? `:${window.location.port}` : '')
      : window.location.hostname
    ),
    enabled: true,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 3,
  });

  return { 
    isLoading, 
    error, 
    data, 
    refetch,
    logo: data?.data?.logo,
    primaryColor: data?.data?.primary_color,
    brandName: data?.data?.brand?.label,
    brandLabel: data?.data?.brand?.label
  };
}
